import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["address", "addressId", "error", "errorMessage", "method", "submit"]

  connect() {
    const selectedMethod = this.methodTargets.find(method => method.dataset.selected === "true")
    const initialMethod = selectedMethod || this.methodTargets[0]

    this.persistedKind = initialMethod?.dataset.kind
    this.selectMethod(initialMethod)
    if (!this.errorTarget.hidden) this.submitTarget.disabled = true
  }

  disconnect() {
    this.request?.abort()
  }

  async select(event) {
    const method = event.currentTarget

    this.clearError()
    this.selectMethod(method)
    if (!method.dataset.addressId || method.dataset.kind === this.persistedKind) return

    await this.persist(method)
  }

  selectMethod(method) {
    if (!method) return

    const kind = method.dataset.kind
    const addressId = method.dataset.addressId || ""

    this.methodTargets.forEach(element => {
      const selected = element === method
      element.classList.toggle("selected", selected)
      element.setAttribute("aria-pressed", selected.toString())
    })

    this.addressTargets.forEach(address => {
      const selected = address.dataset.kind === kind
      address.classList.toggle("is-hidden", !selected)
    })

    this.addressIdTarget.value = addressId
    this.submitTarget.disabled = addressId === ""
  }

  async persist(method) {
    this.request?.abort()
    const request = new AbortController()
    this.request = request
    const previousMethod = this.methodTargets.find(element => element.dataset.kind === this.persistedKind)
    const formData = new FormData(this.element)
    formData.set("address_id", method.dataset.addressId)
    formData.set("selection_only", "true")

    this.element.setAttribute("aria-busy", "true")
    this.methodTargets.forEach(element => {
      element.disabled = true
    })

    try {
      const response = await fetch(this.element.action, {
        method: this.element.method,
        body: formData,
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
          "X-Requested-With": "XMLHttpRequest"
        },
        signal: request.signal
      })

      if (response.status === 422) {
        const data = await response.json()
        this.showError(data.error)
        return
      }

      if (!response.ok) throw new Error(`Unable to select delivery method (${response.status})`)

      this.persistedKind = method.dataset.kind
    } catch (error) {
      if (error.name !== "AbortError") this.selectMethod(previousMethod)
    } finally {
      if (this.request === request) {
        this.request = null
        this.element.removeAttribute("aria-busy")
        this.methodTargets.forEach(element => {
          element.disabled = false
        })
      }
    }
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorTarget.hidden = false
    this.submitTarget.disabled = true
  }

  clearError() {
    this.errorMessageTarget.textContent = ""
    this.errorTarget.hidden = true
  }
}
